import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import beatsService from "../services/Beat.Service";
export const saveBeat = createAsyncThunk("beats/save", async (params, thunkAPI)=> {
        try{
            const data =  await beatsService.save(params);
            return data;
        }catch(exception){
            if (!exception.response) {
            return thunkAPI.rejectWithValue(exception)
            }
            return thunkAPI.rejectWithValue(exception?.response?.data)
        }
    }
)

export const beatList = createAsyncThunk("beats/list", async (params, thunkAPI)=> {
    try{
        let pageData =  Object.assign({}, params.data)
        // if(pageData.page){
        //     pageData.page = pageData.page - 1  
        // }
        const data =  await beatsService.list(pageData);
        return data;
    }catch(exception){
        if (!exception.response) {
        return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
    }
)

const initialState = {
    errors: false,
    success: false,
    loading: false,
    type: '',
    message: '',
    beatList:[],
    totalCount:0
}

const BeatsSlice = createSlice({
    name : "beats",
    initialState,
    reducers:{
        reset:(state, action) =>{
            return {
                ...initialState,
                errors:false,
                success:false,
                loading:false,
                message:'',
                type: '',
                totalCount: 0,
                beatList: []
            }
        }
    },
    extraReducers:{
        [saveBeat.pending]:(state,action) =>{
            state.loading = true
            state.type = "BEAT_SAVE_LOADING"
        }
        ,
        [saveBeat.fulfilled]:(state,action) =>{
            state.loading = false
            state.success = true
            state.errors = false
            state.type = "BEAT_SAVE_SUCCESS"
            state.message = action.payload.msg
        },
        [saveBeat.rejected]:(state,action) =>{
            state.loading = false
            state.success = false
            state.errors = true
            state.type = "BEAT_SAVE_ERROR"
            state.message = action.payload.message
        },
        // list
        [beatList.pending]:(state,action) =>{
            state.loading = true
            state.type = "BEAT_LIST_LOADING"
        },
        [beatList.fulfilled]:(state,action) =>{
            console.log(action.payload)
            state.loading = false
            state.success = true
            state.errors = false
            state.beatList = action.payload.data.docs
            console.log(action.payload.data.totalDocs)
            state.totalCount = action.payload.data.totalDocs
            state.type = "BEAT_LIST_SUCCESS"
        },
        [beatList.rejected]:(state,action) =>{
            state.loading = false
            state.success = false
            state.errors = true
            state.message = action.payload.msg
            state.type = "BEAT_LIST_ERROR"
        }

    }
})

export const { reset } = BeatsSlice.actions
export default BeatsSlice.reducer

